import React, { ReactNode } from "react";
import useStyles from "../Dropdown.style";

export const DropdownSelected = ({
  value,
  label,
  labelPrefix,
}: {
  value: string | string[];
  label?: string;
  labelPrefix?: ReactNode;
}) => {
  const c = useStyles({ value });
  return (
    <span className={c.selected}>
      {labelPrefix} <span className={c.menuItemLabel}>{label}</span>
    </span>
  );
};
